<template>
  <el-dialog
    title="修改手机号"
    :visible="true"
    width="600px"
    :before-close="() => $emit('close')"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      label-suffix="："
      label-width="6rem"
      style="width: 20rem;  margin: 0 auto;"
      :model="ruleForm"
      label-position="left"
    >
      <el-form-item class="phone-form" :label="fullNameLabel">
        <div>{{ fullName }}</div>
      </el-form-item>
      <el-form-item
        class="phone-form"
        label="手机号"
        prop="phone"
        :rules="[{ validator: validator, trigger: 'change' }]"
      >
        <el-input
          v-model="ruleForm.phone"
          style="width:11rem"
          :show-word-limit="true"
          :maxlength="11"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center">
      <el-button plain @click="() => $emit('close')">取消</el-button>
      <el-button type="primary" @click="confirm">
        确认
      </el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  props: {
    fullNameLabel: {
      type: String
    },
    fullName: {
      type: String
    },
    phone: {
      type: [Number, String]
    }
  },
  name: 'updatePhone',
  data() {
    return {
      ruleForm: { phone: '' },
      validator: (rule, value, callback) => {
        const EXP = /^1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[235-8]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|66\d{2})\d{6}$/;
        if (!value) {
          return callback(new Error('手机号不能为空'));
        }
        if (!EXP.test(value)) {
          callback(new Error('手机号格式有误，请重新输入'));
        }
        callback();
      }
    };
  },
  methods: {
    async confirm() {
      if (this.phone === this.ruleForm.phone) {
        this.$message('未作任何修改');
        this.$emit('close');
        return;
      }
      await this.$refs.form.validate();
      this.$emit('finished', this.ruleForm.phone);
    }
  },
  created() {
    this.ruleForm.phone = this.phone;
  }
};
</script>
<style>
.el-form .el-form-item .phone-form {
  display: block;
}
</style>
